import { useApiQuery } from '@/hooks/useApiQuery';
import { apiGet, operationsClient } from '@/lib/api/client';
import { settingsEndpoints } from '@/lib/api/endpoints';
import { settingsKeys } from '@/lib/queryKeys';
import type { QuickBooksFieldMapping } from '@/types/settings';

export function useQbFieldMapping() {
  return useApiQuery<QuickBooksFieldMapping>({
    queryKey: settingsKeys.qbFieldMapping(),
    queryFn: () =>
      apiGet<QuickBooksFieldMapping>(operationsClient, settingsEndpoints.qbFieldMapping()),
    showErrorToast: false,
  });
}
